/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Caption File Name" |
*
* @param {Ateliere_Connect_Caption_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_label = /** @type {((inputs?: Ateliere_Connect_Caption_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du fichier de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiname der Bildunterschrift")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome file didascalia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название файла субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del archivo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标题文件名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションファイル名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन फ़ाइल नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do arquivo de legenda")
	return /** @type {LocalizedString} */ ("Caption File Name")
});